export const raisedPanelSx = {
  borderColor: 'divider',
  boxShadow: 'none',
} as const;
